import useTerms from "../../../hooks/useTerms";
import React from "react";
import { Box, Drawer, IconButton, Tooltip, Typography } from "@mui/material";
import { AssignmentTurnedIn as ConsentIcon, PictureAsPdf as PdfIcon } from "@mui/icons-material";
import { DrawerHeader, DrawerFooter, EmptyState } from "../../atoms";
import { COLORS, TYPO } from "../../../styles/uiConstants";
import { CONSENT_METHOD_LABEL, formatDateTr, personName } from "./practiceSessionFormat";

/**
 * Hastanın onam kayıtları: satır satır (başlık · uygulama · tarih · imzalayan),
 * her satırda PDF çıktısı. Altta "Onam kaydet" (consents:manage).
 */
export default function ConsentListDrawer({ open, onClose, records = [], patientName, onPrint, onRecordNew }) {
  const terms = useTerms();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 480 }, display: "flex", flexDirection: "column", bgcolor: COLORS.white } }}
    >
      <DrawerHeader icon={<ConsentIcon />} title="Onamlar" subtitle={patientName || `${terms.patient} onam kayıtları`} onClose={onClose} />
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", overscrollBehavior: "contain" }}>
        {records.length === 0 ? (
          <Box sx={{ py: 6 }}>
            <EmptyState
              variant="illustrated-sm"
              icon={<ConsentIcon />}
              title="Henüz onam kaydı yok"
              description={onRecordNew ? `${terms.patientGen} imzaladığı onamı aşağıdaki butonla kaydedin.` : `Bu ${terms.patientLower} için kaydedilmiş onam bulunmuyor.`}
            />
          </Box>
        ) : (
          records.map((r) => (
            <Box
              key={r._id}
              sx={{ display: "flex", alignItems: "center", gap: 1.5, px: 3, py: 1.5, borderBottom: `1px solid ${COLORS.slate100}` }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: TYPO.body, fontWeight: 500, color: COLORS.slate800 }}>
                  {r.template?.title || "Onam"}
                </Typography>
                <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500 }}>
                  {[r.practiceName || "Genel onam", formatDateTr(r.signedAt), CONSENT_METHOD_LABEL[r.method]].filter(Boolean).join(" · ")}
                </Typography>
                <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate400 }}>
                  İmzalayan: {r.signedBy}
                  {r.recordedBy ? ` · Kaydeden: ${personName(r.recordedBy)}` : ""}
                </Typography>
              </Box>
              <Tooltip title="PDF çıktısı">
                <IconButton size="small" aria-label="Onam PDF çıktısı" onClick={() => onPrint?.(r)}>
                  <PdfIcon sx={{ fontSize: 20, color: COLORS.slate500 }} />
                </IconButton>
              </Tooltip>
            </Box>
          ))
        )}
      </Box>
      <DrawerFooter
        onCancel={onClose}
        cancelLabel="Kapat"
        onSubmit={onRecordNew}
        submitLabel="Onam Kaydet"
        fullWidth
      />
    </Drawer>
  );
}
